<template>
  <section class="footer">
    <div>©2021 北京拾成拾科技有限公司 版权所有</div>
    <p><a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" class="icp">京ICP备2020039042号-1</a></p>
  </section>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
  props: {},
  mounted() {},
  computed: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.footer {
    margin-top: 15px;
    text-align: center;
    margin-bottom: 15px;
    .icp {
      color:  #7b818d;
      &:hover {
         color:  #7b818d;
      }
    }

}
</style>
